import script from "./ShakyoTaikenDetailNittei.vue?vue&type=script&setup=true&lang=js"
export * from "./ShakyoTaikenDetailNittei.vue?vue&type=script&setup=true&lang=js"

import "./ShakyoTaikenDetailNittei.vue?vue&type=style&index=0&id=0e2979bf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e2979bf"]])

export default __exports__